import { Component, ContentChild, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { PuiFormBodyComponent } from './form-body.component';
import { PuiFormCommandComponent } from './form-command.component';

let nextId = 0;

@Component({
  exportAs: 'puiForm',
  selector: 'pui-form',
  templateUrl: 'form.component.html'
})
export class PuiFormComponent implements OnInit, OnChanges {
  @Input() id = `pui-form-${nextId++}`;
  @Input() formGroup: FormGroup;
  @Input() hideReset = false;
  @Input() submitButton = 'Save';
  @Input() restoreButton = 'Reset';
  @ContentChild(PuiFormBodyComponent) body: PuiFormBodyComponent;
  @ContentChild(PuiFormCommandComponent) command: PuiFormCommandComponent;
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @Output() restore: EventEmitter<any> = new EventEmitter<any>();
  @Output() clear: EventEmitter<any> = new EventEmitter<any>();

  hideResetButton: boolean;

  private oldValue: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup']) {
      this.oldValue = this.formGroup.value;
    }
  }

  ngOnInit() {
    // hide cancel button if there is no subscribers
    this.hideResetButton = (this.restore.observers.length === 0 ? true : false) && this.hideReset;
  }

  // TODO: shouldn't be necessary
  resetValue(val: any): void {
    this.formGroup.patchValue(val);
    this.oldValue = val;
    this.formGroup.markAsPristine();
  }

  _onSubmit(): void {
    if (this.formGroup && this.formGroup.dirty && this.formGroup.valid) {
      this.submit.emit(this.formGroup.value);

      // sync up
      this.oldValue = this.formGroup.value;
      this.formGroup.markAsPristine();
    }
  }

  _onReset(e: Event) {
    e.stopPropagation();
    if (this.formGroup) {
      // formGroup directive listens on 'reset' as well, which will reset all fields to null
      this.restore.emit(this.formGroup.value);

      // reset form
      this.formGroup.reset(this.oldValue);
      this.formGroup.markAsPristine();
    }
  }

  _onEnter(): void {
    this._onSubmit();
  }
}
